import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { SimplePdfViewerComponent, SimplePDFBookmark } from 'simple-pdf-viewer';
import { SelectItem, Message } from 'primeng/api';
import { Router } from '@angular/router';
import { StoreService } from '../store.service';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-manage-item',
  templateUrl: './manage-item.component.html',
  styleUrls: ['./manage-item.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService]
})
export class ManageItemComponent implements OnInit {

  @ViewChild(SimplePdfViewerComponent) private pdfViewer: SimplePdfViewerComponent;
  bookmarks: SimplePDFBookmark[] = [];


  lstProduct: any = [];
  qboItems: SelectItem[] = [];
  loadingMessage: any = "Loading...";
  qboDocumentSelected: any; //Selected Qbo Document
  hdr: any = {
    ItemListID: '',
    ID: 0,
    ProductCode: '',
    VendorName: '',
    ItemName: ''

  }; //Selected Qbo Document

  qboitemsTemp: any = [];
  public msgs: Message[] = [];
  display: boolean = false;

  constructor(private router: Router,
    private api: ApiService,
    private ss: StoreService,
    private http: HttpClient,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.bindItems();
    this.getProduct()
  }

  bindItems() {
    this.qboitemsTemp = this.ss.fetchQboItem();
    this.qboItems.push({ label: '', value: '' });
    if (this.qboitemsTemp == null) return;

    this.qboitemsTemp.forEach(element => {
      this.qboItems.push({ label: element.FullName, value: element.ListID });
    });
  }

  onChangeItem(line: any, itemlst: any) {
    if (line) {
      line.QboItemID = itemlst.QboItemID;
      line.QboItemName = itemlst.QboItemName;
    }
  }

  getProduct() {
    console.log(this.hdr);
    this.spinner.show();
    this.loadingMessage = "Processing...";
    this.api.get('Rah/GetSalesItem', '').subscribe(
      (res: {}) => this.successGetproduct(res),
      error => this.failedApproveDoc(<any>error));
  }

  successGetproduct(resp: any) {
    this.msgs = [];
    this.spinner.hide();
    console.log(resp);
    this.lstProduct = resp.Data;
  }

  failedApproveDoc(resp: any) {
    this.msgs = [];
    this.msgs.push({ severity: 'Error', summary: 'Failed to get product', detail: 'Failed get product .' });
    this.spinner.hide();
  }

  save() {
    this.msgs = [];
    this.spinner.show();

    if (this.hdr.ProductCode.length == 0 || this.hdr.ItemListID.length == 0 ) {
      this.msgs.push({ severity: 'error', summary: 'Please Fill Required detail', detail: '' });
      this.spinner.hide();
      return;
    }
    console.log('this.hdr');
    console.log(this.hdr);
    console.log(this.hdr);
      var lines1 = this.lstProduct.filter(xx => xx.ProductCode == this.hdr.ProductCode.trim() );
      if (lines1.length > 0) {

        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'you have entered duplicate Product Code', detail: '' });
        this.spinner.hide();
        return;
      }

      var lines = this.lstProduct.filter(xx => xx.ProductCode == this.hdr.ProductCode.trim()  && xx.ItemListID == this.hdr.ItemListID);

      if (lines.length > 0) {

        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'you have entered duplicate Product Code and Item Name', detail: '' });
        this.spinner.hide();
        return;
      }
    


    this.loadingMessage = "Processing...";
    this.api.post('Rah/SaveSalesItem', this.hdr).subscribe(
      (res: {}) => this.successSavetproduct(res),
      error => this.failedApproveDoc(<any>error));
  }

  // save() {
  //   this.msgs = [];
  //   this.spinner.show();

  //   if (this.hdr.ID === 0) {
  //     var lines = this.lstProduct.filter(xx => xx.ProductCode == this.hdr.ProductCode && xx.ItemListID == this.hdr.ItemListID);

  //     if (lines.length > 0) {

  //       this.msgs = [];
  //       this.msgs.push({ severity: 'warn', summary: 'you have entered duplicate Product Code and Item Name', detail: '' });
  //       this.spinner.hide();
  //       return;
  //     }
  //   }


  //   console.log('lines');
  //   console.log(lines)

  //   this.loadingMessage = "Processing...";
  //   this.api.post('Rah/SaveSalesItem', this.hdr).subscribe(
  //     (res: {}) => this.successSavetproduct(res),
  //     error => this.failedApproveDoc(<any>error));
  // }

  successSavetproduct(resp: any) {
    this.msgs = [];
    this.spinner.hide();
    console.log(resp);
    this.getProduct();
    this.hdr.ItemListID = '';
    this.hdr.ProductCode = '';
  }

  edit(rowValue) {
    this.hdr.ItemListID = rowValue.ItemListID;
    this.hdr.ID = rowValue.ID;
    this.hdr.ProductCode = rowValue.ProductCode;


    this.hdr.VendorName = rowValue.VendorName
    ;this.hdr.ItemName = rowValue.ItemName;
  }

  delete(rowValue) {
    this.api.post('Rah/DeleteSalesItem', rowValue).subscribe(
      (res: {}) => this.successDeleteSalesItem(res),
      error => this.failedDeleteSalesItem(<any>error));
  }

  successDeleteSalesItem(resp: any) {
    this.msgs = [];
    this.spinner.hide();
    console.log(resp);
    this.getProduct();
    this.hdr.ItemListID = '';
    this.hdr.ProductCode = '';
  }

  failedDeleteSalesItem(resp: any) {
    this.msgs = [];
    this.msgs.push({ severity: 'Error', summary: 'Failed to delete item', detail: 'somthing is wrong when try to delete item' });
    this.spinner.hide();
  }

}
